import {
  RESET_CREATE_ACCOUT_DATA,
  SET_USER_CREATE_ACCOUT_DATA,
} from '../../constants/actions';

import config from '../../constants/config';

let [gender, seeking] = [null, null];
if (
  config.GENDER_SEEKING_SIGNUP_LOGIN &&
  config.GENDER_SEEKING_SIGNUP_LOGIN.visibleOptions &&
  config.GENDER_SEEKING_SIGNUP_LOGIN.visibleOptions[0]
) {
  let genders = config.GENDER_SEEKING_SIGNUP_LOGIN.visibleOptions[0].split('_');
  gender = parseInt(genders[0], 10);
  seeking = parseInt(genders[1], 10);
}

const initialState = {
  step: 1, // control steps on on modal forms
  stepIndex: 1, // control steps on index form
  gender,
  seeking,
  areGendersPreselectedFromUrlData: false,
  genderApiConfigDataLodaded: false,
  genderAndSeekingSelectedValue: 0,
  age: 0,
  minAge: 18,
  maxAge: 99,
  lat: 0,
  lon: 0,
  username: '',
  email: '',
  password: '',
  location: '',
  bonus: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case RESET_CREATE_ACCOUT_DATA:
      return initialState;
    case SET_USER_CREATE_ACCOUT_DATA:
      const currentState = { ...state };
      for (let key in action.data) {
        currentState[key] = action.data[key];
      }
      return currentState;
    default:
      return state;
  }
}
